import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import Blocker from "../../Misc/Blocker";
function HeaderSearch() {
  const [searchText, searchTextSet] = useState("");
  const [pending, setPending] = useState(false);
  const inputEl = React.createRef();

  const searchKeyPress = (e) => {
    if (e.key === "Enter") {
      setPending(true);
      document.location.replace("/search/?q=" + searchText);
    }
  };

  const searchSetFocus = () => {
    if (inputEl.current) {
      inputEl.current.focus();
    }
  };

  const searchToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div className="topbar-item">
      <div
        className="btn btn-icon btn-clean btn-lg btn-dropdown mr-1"
        ref={ref}
        onClick={(e) => {
          e.preventDefault();
          onClick(e);
        }}
      >
        <span className="svg-icon svg-icon-xl svg-icon-primary">
          <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <rect x="0" y="0" width="24" height="24" />
              <path
                d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                fill="#000000"
                fillRule="nonzero"
                opacity="0.3"
              />
              <path
                d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                fill="#000000"
                fillRule="nonzero"
              />
            </g>
          </svg>
        </span>
      </div>
    </div>
  ));

  return (
    <Dropdown onClick={() => setTimeout(() => searchSetFocus(), 150)}>
      <Dropdown.Toggle as={searchToggle} id="searchToggle" />
      <Dropdown.Menu
        alignRight
        className="p-0  dropdown-menu-lg"
        popperConfig={{
          modifiers: [
            {
              name: "offset",
              options: {
                offset: [0, 10],
              },
            },
          ],
        }}
      >
        <div
          className="quick-search quick-search-dropdown"
          id="kt_quick_search_dropdown"
        >
          <div className="quick-search-form">
            <Blocker on={pending}>
              <div className="input-group">
                <div className="input-group-prepend">
                  <span className="input-group-text">
                    <span className="svg-icon svg-icon-lg">
                      <svg
                        width="24px"
                        height="24px"
                        viewBox="0 0 24 24"
                        version="1.1"
                      >
                        <g
                          stroke="none"
                          strokwidth="1"
                          fill="none"
                          fillRule="evenodd"
                        >
                          <rect x="0" y="0" width="24" height="24" />
                          <path
                            d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                            fill="#000000"
                            fillRule="nonzero"
                            opacity="0.3"
                          />
                          <path
                            d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                            fill="#000000"
                            fillRule="nonzero"
                          />
                        </g>
                      </svg>
                    </span>
                  </span>
                </div>
                <input
                  value={searchText}
                  onKeyPress={(e) => searchKeyPress(e)}
                  onChange={(e) => searchTextSet(e.target.value)}
                  type="text"
                  className="form-control"
                  placeholder="Поиск..."
                  ref={inputEl}
                />
                <div className="input-group-append">
                  <span className="input-group-text"></span>
                </div>
              </div>
            </Blocker>
          </div>
          <div
            className="quick-search-wrapper scroll"
            data-scroll="true"
            data-height="325"
            data-mobile-height="200"
          ></div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
export default HeaderSearch;
